import { render, staticRenderFns } from "./CreatorChannelTypes.vue?vue&type=template&id=552f1c08&"
import script from "./CreatorChannelTypes.vue?vue&type=script&lang=ts&"
export * from "./CreatorChannelTypes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports